import { c as _c } from "react/compiler-runtime";
import { getMarkupsBoardColumns, MARKUPS_BOARD_STATUSES } from "@pages/project-details/project-markups/board/project-markups-board-utils";
import { getMarkupsShownInCalendar } from "@pages/project-details/project-markups/calendar/project-markups-calendar-utils";
import { useMarkupsCalendarPreferences } from "@pages/project-details/project-markups/calendar/use-markups-calendar-preferences";
import { useMarkupsViewQueryParams } from "@pages/project-details/project-markups/calendar/use-markups-view-query-params";

/**
 * Returns the markups shown in the current view, in the order it shows them: in the table as
 * sorted by its rows, if known, column by column on the board, or the ones due on a shown day in
 * the calendar
 */
export function useMarkupsShownInView(markups, sortedTableRowIds) {
  const $ = _c(10);
  const {
    viewMode,
    calendarView,
    visibleDate
  } = useMarkupsViewQueryParams();
  const [t0] = useMarkupsCalendarPreferences();
  const {
    shouldShowWeekends
  } = t0;
  if (viewMode === "calendar") {
    let t1;
    if ($[0] !== calendarView || $[1] !== markups || $[2] !== shouldShowWeekends || $[3] !== visibleDate) {
      t1 = getMarkupsShownInCalendar(markups, {
        visibleDate,
        calendarView,
        shouldShowWeekends
      });
      $[0] = calendarView;
      $[1] = markups;
      $[2] = shouldShowWeekends;
      $[3] = visibleDate;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (viewMode === "board") {
    let t1;
    if ($[5] !== markups) {
      const columns = getMarkupsBoardColumns(markups);
      t1 = MARKUPS_BOARD_STATUSES.flatMap(status => columns[status]);
      $[5] = markups;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (sortedTableRowIds) {
    let t1;
    if ($[7] !== markups || $[8] !== sortedTableRowIds) {
      const markupsById = new Map(markups.map(_temp));
      t1 = sortedTableRowIds.flatMap(id => markupsById.get(id) ?? []);
      $[7] = markups;
      $[8] = sortedTableRowIds;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  return markups;
}
function _temp(markup) {
  return [markup.id, markup];
}